import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import jwt_decode from "jwt-decode";
import { callRefreshToken } from "../../slices/onboard/LoginSlice";
import { REACT_LOGIN } from "../../actions/EndPoints";

export default function RefreshToken() {
  const dispatch = useDispatch();
  const store = useSelector((state) => state);

  useEffect(() => {
    if (store.user.tokenRefreshTimer > 60000) {
      setInterval(() => {
        refreshToken();
      }, store.user.tokenRefreshTimer);
    }
  }, [process.env.REACT_APP_ACCESS_TOKEN]);

  const refreshToken = async () => {
    const refreshTokenValue = localStorage.getItem(
      process.env.REACT_APP_REFRESH_TOKEN
    );
    if (refreshTokenValue) {
      const payload = {
        refreshToken: refreshTokenValue,
      };
      dispatch(callRefreshToken(payload));
    }
  };
  return <></>;
}
